import { render, staticRenderFns } from "./IssueCategory.vue?vue&type=template&id=533397cc&scoped=true&"
import script from "./IssueCategory.vue?vue&type=script&lang=js&"
export * from "./IssueCategory.vue?vue&type=script&lang=js&"
import style0 from "./IssueCategory.vue?vue&type=style&index=0&id=533397cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533397cc",
  null
  
)

export default component.exports